import $ from 'jquery';

const BASE_SELECTOR: string = ".notification-wrapper--dynamic";
const notificationTemplate = require('./view/notification.handlebars');
const DEFAULT_NOTIFICATION_TIMEOUT = 3000;

export class NotificationUI {

  /**
   * Wrapper ($base)
   * All notfications are inside this wrapper
   */
  private $base: JQuery = $(BASE_SELECTOR);
  private id: string = this.makeId();
  private focus: boolean = false;

  public constructor() {}

  public render(type, title, text, focus: boolean, duration: number = DEFAULT_NOTIFICATION_TIMEOUT) {
    this.focus = focus;

    this.$base.prepend(notificationTemplate({
      type: type,
      title: title,
      text: text,
      id: this.id,
    }));

    if (focus) {
      $("body").find(".notification-wrapper--dynamic").wrap('<div class="notification-wrapper--focus"></div>');
    }

    this.$base.find('#n-' + this.id + ' .notification__close').on('click', () => this.hide());
    this.show(duration);
  }

  private makeId() : string {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 10; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  private show(duration = DEFAULT_NOTIFICATION_TIMEOUT) {
    if (this.countAllNotifications() >= 4) {
      $('.notification').not('.notification--permanent').first().remove();
    }

    if (!this.focus) {
      window.setTimeout(() => {
        this.hide();
      }, duration);
    }
  }

  private countAllNotifications() : number {
    return $('.notification').not('.notification--permanent').length;
  }

  private hide() {
    if (focus) {
      $('body')
        .find(".notification-wrapper--dynamic")
        .unwrap();
    }

    $("#n-" + this.id).fadeOut(
      400,
      "linear",
      () => {
        $("#n-" + this.id).remove();
      }
    );
  }
}
